import isEmpty from 'lodash/isEmpty';
import qs from 'query-string';
export function parseQueries(queryString) {
  return qs.parse(queryString);
}
export function parseQueriesFromUrl(url) {
  if (url && url.indexOf('?') >= 0) {
    const queryString = url.substring(url.indexOf('?') + 1);
    return qs.parse(queryString);
  }
  return {};
}
export function getUrlWithoutQueries(url) {
  const resultUrl = url.split('?');
  return resultUrl[0];
}
export function getUrlWithQueries(url, queries) {
  if (!isEmpty(queries)) {
    return `${url}?${qs.stringify(queries)}`;
  }
  return url;
}
export function getUrlWithOverridenQueries(url, newQueries) {
  if (!isEmpty(newQueries)) {
    const parsedQueries = parseQueriesFromUrl(url);
    return getUrlWithQueries(getUrlWithoutQueries(url), {
      ...parsedQueries,
      ...newQueries
    });
  }
  return url;
}
export function getUrlAppendedWithQueryParamSeparator(uri) {
  let currentUri = uri;
  if (currentUri.indexOf('?') === -1) {
    currentUri += '?';
  } else {
    currentUri += '&';
  }
  return currentUri;
}
export function removeHttpProtocol(url) {
  return url.replace(/^https?:\/\//, '');
}